import React from "react"
import IntroSection from "../components/IntroSection";
import QASolutions from "../components/QASolutions";
import BlueSectionDivider from "../components/BlueSectionDivider";
import QAProcess from  "../components/QAProcess"
import CustomerTestimonials from "../components/CustomerTestimonials";
import QABenefits from "../components/QABenefits";
import QAAwards from "../components/QAAwards";
import CountriesSection from "../components/CountriesSection";
import QAProjects from "../components/QAProjects";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import QAFaq from "../components/QAFaq";
import QAResources from "../components/QAResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
const QualityAssurance = () =>{
    return(
        <div>
            <IntroSection title ="INCREMENTAL QUALITY ASSURANCE PROCESS" paragraph = "Focus on prevention and reduce technical debt" backgroundImage="/images/sd-bg.webp"/>
            <QASolutions para1 ="Our Quality Assurance Process is a systematic approach that includes the entire software development lifecycle and collaborates with all business operations." para2="The QA ensures error-free software development by focusing on prevention rather than just detection. This process is essential in the software development lifecycle as it guarantees that software development processes are followed correctly and that the end product fulfills quality requirements, which leads to greater customer satisfaction and reputation."/>
            <BlueSectionDivider/>
            <QAProcess/>
            
            <QABenefits/>
            
            <BlueSectionDivider/>
            <CountriesSection/>
            <BlueSectionDivider/>
            <QAProjects/>
            <BlueSectionDivider/>
            <TeamSection/>
            <WhyUsSection/>
            <WorkingModelSection/>
            <TechStackSection/>
            <BlueSectionDivider/>
            <QAFaq/>
            <BlueSectionDivider/>
            
            <ContactSection backgroundColor="#057af0ff"/>
            <Footer/>

        </div>
    )
}
export default QualityAssurance;